import { gql } from "@apollo/client";

export const FETCH_PRICE_LISTS = gql`
  query FETCH_PRICE_LISTS {
    priceLists {
      id
      company
      name
      currency
      odooId
      createdBy {
        id
        email
      }
      customers {
        id
      }
    }
  }
`;

export const FETCH_PRICE_LIST = gql`
  query FETCH_PRICE_LIST($id: ID!) {
    priceList(id: $id) {
      id
      company
      name
      currency
      odooId
      createdBy {
        id
      }
      customers {
        id
        name
      }
      latestPrices(prefetchProductFields: ["images"]) {
        id
        product {
          id
          company
          odooId
          odooIdInc
          number
          version
          countryCodeOfOrigin
          name
          images: computedImages(size: "300x300") {
            id
            url
          }
        }
        useFixedMargin
        fixedMargin
        discountPercentage
        price
        finalPrice
        state
        updatedAt
      }
    }
  }
`;

export const DELETE_PRICE_LISTS = gql`
  mutation DELETE_PRICE_LISTS($ids: [ID!]!) {
    deletePriceLists(ids: $ids) {
      result
    }
  }
`;

export const FETCH_PRODUCT_COSTS = gql`
  query FETCH_PRODUCT_COSTS(
    $ids: [ID!]!
    $company: String!
    $currency: String!
  ) {
    products(ids: $ids, prefetchCost: true) {
      total
      results {
        id
        productCost(company: $company, currency: $currency) {
          cost
          date
        }
      }
    }
  }
`;

export const UPDATE_PRICE_LIST_ITEMS = gql`
  mutation UPDATE_PRICE_LIST_ITEMS(
    $priceListId: ID!
    $salesPrices: [SalesPriceInputType]!
  ) {
    updatePriceListItems(priceListId: $priceListId, salesPrices: $salesPrices) {
      priceList {
        id
      }
    }
  }
`;

export const FETCH_ODOO_PRODUCT_AVG_SALES_PRICE = gql`
  query FETCH_ODOO_PRODUCT_AVG_SALES_PRICE {
    odooProductAvgSalesPriceForLast365Days
  }
`;

export const SAVE_PRICE_LIST_ITEM = gql`
  mutation SAVE_PRICE_LIST_ITEM(
    $priceListId: ID!
    $productId: ID!
    $price: Float!
    $discountPercentage: Float!
    $useFixedMargin: Boolean
    $fixedMargin: Float
    $state: String
    $createIncOdooProduct: Boolean
    $odooIncProductCategoryId: Int
  ) {
    savePriceListItem(
      priceListId: $priceListId
      productId: $productId
      price: $price
      discountPercentage: $discountPercentage
      useFixedMargin: $useFixedMargin
      fixedMargin: $fixedMargin
      state: $state
      createIncOdooProduct: $createIncOdooProduct
      odooIncProductCategoryId: $odooIncProductCategoryId
    ) {
      product {
        id
        salesPrices {
          id
          price
          discountPercentage
          useFixedMargin
          fixedMargin
          finalPrice
          state
        }
        odooIdInc
      }
    }
  }
`;

export const DELETE_PRICE_LIST_ITEMS = gql`
  mutation DELETE_PRODUCT_SALES_PRICE($priceListId: ID!, $productIds: [ID!]!) {
    deletePriceListItems(priceListId: $priceListId, productIds: $productIds) {
      res
    }
  }
`;
